<template>
  <div v-if="isOpen" class="modal-overlay" @click="handleOverlayClick">
    <div ref="modalRef" class="modal">
      <span class="close-button" @click="closeModal">X</span>
      <span :class="['icon', type]"></span>
      <p>{{ $t(message) }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useModalStore } from '@/stores';

const modalStore = useModalStore();
const modalRef = ref(null);

const { isOpen, type, message } = storeToRefs(modalStore);

const closeModal = () => {
  modalStore.closeModal();
};

const handleOverlayClick = (event) => {
  if (modalRef.value && !modalRef.value.contains(event.target)) {
    closeModal();
  }
};

</script>


<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  position: relative;
  min-width: 300px;
  max-width: 600px;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

p {
  text-align: center;
  word-wrap: break-word;
}
.icon {
  display: block;
  max-width: 80px;
  margin: 20px auto;
  font-size: 24px;
}
.success {
  content: url('/src/assets/icons/success.png');
}
.error {
  content: url('/src/assets/icons/error.png');
}
.warning {
  content: url('/src/assets/icons/warning.png');
}
.info {
  content: url('/src/assets/icons/info.png');
}
</style>